module.exports = __webpack_public_path__ + "img/icon_submenu5dark.6c7f0962.svg";